import * as types from '../actions/types';
import {themes} from '../actions/theme-actions';

const initState = {
    ...themes['default']
};

export default function ThemeReducer (state = initState, action) {

    switch (action.type)
    {
        case types.SET_THEME:
            return action.theme;

        default:
            return state;
    }

}
